// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"LoadingSpinner_loadingSpinner__3XvWx"};